import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './StatusMessages.module.css'
import connectToStores from '../../utils/connectToStores'
import MessageStore from '../../stores/MessageStore'

class StatusMessages extends Component {
  static propTypes = {
    messages: PropTypes.arrayOf(PropTypes.object)
  }
  static defaultProps = {
    messages: []
  }
  static getStores () {
    return [MessageStore]
  }
  static getPropsFromStores () {
    return MessageStore.getState()
  }  

  render () {
    if (this.props.messages.length == 0) return null
    return (
      <div className={styles['status-messages']}>
      {this.props.messages
        .map((message, i) =>
          <p key={`message_${i}`} className={styles.message}>{message.messages.sv}</p>)}
      </div>            
    )
  }
}

export default connectToStores(StatusMessages)
